// delay in milliseconds between keystrokes before submitting a search
export const searchKeystrokeDelay = 1000;
